<div class="action-content" [class.is-inactive]="selectedLeadDetails?.Editor?.Inactive && userId !== selectedLeadDetails?.Editor?.Id">
  @if (selectedLeadDetails?.Editor && (selectedLeadDetails?.Lead?.LimitedAccess || !isDuplicateLead && userId !== selectedLeadDetails?.Editor?.Id)) {
    <div class="inactive-content">
      <div class="editor-row">
        <img alt="Contact" [src]="selectedLeadDetails?.Editor?.AvatarURL">
        <div>
          <div class="editor-name">{{ selectedLeadDetails?.Editor?.FirstName }} {{ selectedLeadDetails?.Editor?.LastName }}</div>
          <div class="editor-organization">{{ selectedLeadDetails?.Editor?.Organisation }}</div>
        </div>
      </div>
      @if (!!selectedLeadDetails?.Editor?.Email) {
        <a href="tel: {{selectedLeadDetails?.Editor?.Email}}"
        class="editor-data">{{selectedLeadDetails?.Editor?.Email}}</a>
      }
      @if (!!selectedLeadDetails?.Editor?.Phone) {
        <a href="tel: {{selectedLeadDetails?.Editor?.Phone}}"
        class="editor-data">{{selectedLeadDetails?.Editor?.Phone}}</a>
      }
      @if (!!selectedLeadDetails?.Editor?.Mobile) {
        <a href="tel: {{selectedLeadDetails?.Editor?.Mobile}}"
        class="editor-data">{{selectedLeadDetails?.Editor?.Mobile}}</a>
      }
      @if ((selectedLeadDetails?.Editor?.Inactive && userId !== selectedLeadDetails?.Editor?.Id)) {
        <div class="inactive-text"
          >
          <mat-icon>cancel</mat-icon>
          <span fiTranslation="REQUEST_DETAIL_USER_INACTIVE"></span>
        </div>
      }
    </div>
  }

  <div class="action-row">
    <div>
      <div class="action-title" fiTranslation="REQUEST_OVERVIEW_COLUMNS_HEADLINE_STATUS"></div>
      {{ selectedLeadDetails?.Lead?.StatusText }}
    </div>

    <div>
      <div class="action-title" fiTranslation="REQUEST_OVERVIEW_COLUMNS_HEADLINE_DUE_DATE"></div>
      <fi-lead-status
        class="status-box"
        [leadData]="selectedLeadDetails"
        [compactView]="true"
        [showStatusLabel]="false">
      </fi-lead-status>
    </div>
  </div>

  @if (actionsCount > 0) {
    <div class="action-buttons">
      @if (isDuplicateLead) {
        <button class="suggested" (click)="doDuplicateAction()">
          <img src="/assets/icons/duplicate.svg" alt="duplicate-icon">
          <span fiTranslation="ALT_TEXT_DUPLICATE_CHECK"></span>
        </button>
      }
      @if (!isDuplicateLead) {
        @if (selectedLeadDetails?.SuggestedAction && !selectedLeadDetails?.SuggestedAction.Hidden) {
          <button class="suggested" (click)="doAction(selectedLeadDetails?.SuggestedAction)">
            <img alt="Action" [src]="selectedLeadDetails?.actionIconUrl">
            {{ selectedLeadDetails?.SuggestedAction.Label }}
          </button>
        }
        @if (hideAdditionalActions) {
          <button class="additional-actions" (click)="openAdditionalActions = !openAdditionalActions">
            <span fiTranslation="REQUEST_DETAIL_ADDITIONAL_ACTIONS"></span>
            <img
              class="arrow"
              [class.open]="openAdditionalActions"
              src="/assets/icons/arrow-up.svg"
              alt="Arrow">
            </button>
          }
          <div class="menu" [class.only-one-item]="!hideAdditionalActions" [class.show]="openAdditionalActions || !hideAdditionalActions">
            @for (action of selectedLeadDetails?.Actions; track action) {
              @if (!action.Hidden && action.Name !== selectedLeadDetails?.SuggestedAction?.Name) {
                <button [class.suggested]="!selectedLeadDetails?.SuggestedAction && action.Name === 'LEAD_TAKEOVER'" (click)="doAction(action)">
                  <img alt="Action" [src]="action.actionIconUrl">
                  {{ action.Label }}
                </button>
              }
            }
            @if (!isDuplicateLead && !selectedLeadDetails?.Editor?.Inactive && mainLeadId === selectedLeadDetails?.Lead.Id) {
              <button (click)="downloadLead()">
                <img alt="Action" src="/assets/icons/new/download.svg">
                <span fiTranslation="BUTTON_DOWNLOAD_LIST"></span>
              </button>
            }
            @if (!isDuplicateLead && mainLeadDetails?.CanDelete) {
              <button (click)="openDeleteDialog()">
                <img alt="Action" src="/assets/icons/new/trash.svg">
                <span fiTranslation="BUTTON_DELETE_LEAD"></span>
              </button>
            }
          </div>
        }
      </div>
    }

    @if (!!selectedLeadDetails?.Lead?.ExternalEmail) {
      <div class="external-email-container">
        <div fiTranslation="REQUEST_DETAIL_EXTERNAL_USER"></div>
        @if (selectedLeadDetails?.Lead?.MandantDesc) {
          <div>
            {{ selectedLeadDetails?.Lead?.MandantDesc }}
          </div>
        }
        <a href="mailto:{{selectedLeadDetails?.Lead?.ExternalEmail}}"
          class="email-block" [innerHTML]="(selectedLeadDetails?.Lead?.ExternalEmail + '\n' + (selectedLeadDetails?.Lead?.ExternalDesc ?? '')) | replace : '\n' : '<br>'">
        </a>
      </div>
    }
  </div>
